import React from 'react';
import { Empty, Table } from 'antd';
import classes from './DocumentsResearch.module.scss';
import { getDocumentComparisonColumns } from './helpers/columns';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'store/hook';
import getDateWithTimeZone from 'helpers/getDateWithTimeZone';
import ReportFooter from './ReportFooter';
import { availableIconFormat, documnentIcons } from 'helpers/documentIcons';

const getIcon = (extension: string) => {
  const typeVersion = availableIconFormat.includes(extension)
    ? extension
    : 'default';
  const iconVersion = typeVersion as keyof typeof documnentIcons;
  return iconVersion as keyof typeof documnentIcons;
};


export default function DocumentChanges() {
  const { t } = useTranslation();
  
  const rawDocumentData = useAppSelector((state) => state.research.reportDocumentRawData);
  const userData = useAppSelector((state) => state.userData.userData);

  const compareData = React.useMemo(() => {
    if (!rawDocumentData || !userData) return [];

    const { previous, current } = rawDocumentData;

    return [
      {
        key: 'name',
        label: t('Report.info.name'),
        previous: previous?.name || '-',
        current: current?.name || '-'
      },
      {
        key: 'extension',
        label: t('Report.info.extension'),
        previous: previous?.extension || '-',
        current: current?.extension || '-'
      },
      {
        key: 'size',
        label: t('Report.info.size'),
        previous: previous?.size ? `${previous?.size} bytes` : '-',
        current: current?.size ? `${current?.size} bytes` : '-'
      },
      {
        key: 'author',
        label: t('Report.info.author'),
        previous: previous?.author || '-',
        current: current?.author || '-'
      },
      {
        key: 'created_at',
        label: t('Report.info.created_at'),
        previous: previous?.created_at ? getDateWithTimeZone(previous?.created_at, userData.date_format) : '-',
        current: current?.created_at ? getDateWithTimeZone(current?.created_at, userData.date_format) : '-'
      }
    ];
  }, [rawDocumentData, userData, t]);

  const columns = getDocumentComparisonColumns(
    t, 
    getIcon, 
    rawDocumentData?.previous?.extension, 
    rawDocumentData?.current?.extension
  );

  return (
    <div className={classes.info}>
      <Table
        dataSource={compareData}
        columns={columns}
        className={classes.compareTable}
        pagination={false}
        size='small'
        locale={{
          emptyText: <div className={classes.emptyText}><Empty /></div>,
        }}
      />
      <ReportFooter />
    </div>
  );
}
